import fetch from '@/api/fetch'

/** 获取当前用户所在企业及其子企业 */
export const getCurrOrgWidthSub = () => fetch.get('/ent/org/curr/withsub')

/** 获取当前企业部门树 */
export const getCurrEnterpriseUnitTree = params => fetch.get('/ent/org/unit/list/curr/tree', { params });


/** 获取企业部门树 */
export const getEnterpriseUnitTree = params => fetch.get('/ent/org/unit/list/tree', { params });


/** 通过id查询企业信息 */
export const getEnterpriseById = id => fetch.get(`/ent/org/id/${id}`);


/** 保存企业信息 */
export const saveOrg = org => fetch.post('/ent/org/save', org);


/** 通过id查询部门信息 */
export const getUnitById = id => fetch.get(`/ent/unit/id/${id}`);

/** 保存部门信息 */
export const saveUnit = unit => fetch.post('/ent/unit/save', unit);


/** 获取部门直接人员申请 */
export const getUserApplysByUnitId = id => fetch.get(`/ent/unit/user/list/id/${id}`);


/** 获取企业直接人员申请 */
export const getUserApplysByOrgId = id => fetch.get(`/ent/org/user/list/id/${id}`);

/** 删除企业、部门人员 */
export const deleteOrgUnitUser = userOrgUnitId => fetch.delete(`/ent/user/delete/id/${userOrgUnitId}`);

/** 加入企业、部门审核 */
export const userApplyAudit = apply => fetch.post('/ent/join/audit', apply);


/** 删除子公司 */
export const deleteSubOrgById = orgId => fetch.delete(`/ent/org/delete/id/${orgId}`)

/** 删除部门 */
export const deleteUnitById = unitId => fetch.delete(`/ent/unit/delete/id/${unitId}`)
